import { useApplicationContext } from '../utils/applicationContext';

// @todo сделаем на нормальных данных, когда будет готов бэк, прогресс тут https://jira.cian.tech/browse/SUT-289
export const useIsDailyrentOnlineBooking = () => {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Dailyrent.FakeDailyrentOnlineBooking.Enabled');
};
